<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        ></Input>
        <DatePicker
          type="month"
          placement="bottom-end"
          placeholder="选择月份"
          style="width: 100px; margin-right: 8px"
          v-model="yearMonth"
          @on-change="changeDate"
        />
        <Button
          type="default"
          style="margin-right: 12px"
          @click="loadSalesOrderProfit()"
        >刷新</Button>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ salesOrderProfitTotalCounts }}条</span>
          <Page
            :total="Number(salesOrderProfitTotalCounts)"
            :page-size="limit"
            @on-change="loadSalesOrderProfit"
            show-total
            simple
            style="min-width: 160px"
          />
        </div>
        <Button
          type="primary"
          style="margin-right: 12px"
          @click="calcSalesOrderProfitMethed"
        >计算订单利润</Button>
        <Button
          type="primary"
          style="margin-right: 12px"
          @click="coverSalesOrdersCalcMethed"
        >覆盖之前数据</Button>
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        :height="tableHeight-50"
        :loading="tableLoading"
        :data="salesOrderProfitList"
        :summary-method="handleSummary"
        show-summary
        border
      ></Table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";

export default {
  name: 'SalesOrderProfitPage',
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      yearMonth: null,
      limit: 999,
      page: 0,
      filterQuery: {},
      numberDigit: 0,
      tableLoading: false,
      columns: [
        {
          title: "客户",
          key: "customer",
          fixed: "left",
          width: 250,
          render: (h, params) => {
            return h(
              "span",
              {
                style: { cursor: "pointer", color: "#42b983" },
                on: {
                  click: () => {
                    this.$refs.CustomerCommentDrawer.openDrawer(
                      params.row,
                    );
                  },
                },
              },
              params.row.customer.name
            );
          },
        },
        {
          title: "公司",
          key: "company",
          fixed: "left",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.company.abbr ? params.row.company.abbr : params.row.company.name
            );
          },
        },
        {
          title: "销量",
          key: "volFinal",
          width: 100,
          align: "right",
          sortable: true,
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.volFinal)),
        },
        {
          title: "销售额",
          key: "salesAmountFinal",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.salesAmountFinal)),
        },
        {
          title: "材料成本",
          key: "materialCost",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.materialCost)),
        },
        {
          title: "复配费",
          key: "manufactCost",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.manufactCost)),
        },
        {
          title: "运费",
          key: "transCost",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.transCost)),
        },
        {
          title: "业务费",
          key: "promoFee",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.promoFee)),
        },
        {
          title: "成本无税",
          key: "totalCostBeforeTax",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.totalCostBeforeTax)),
        },
        {
          title: "税",
          key: "tax",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.tax)),
        },
        {
          title: "成本含税",
          key: "totalCost",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.totalCost)),
        },
        {
          title: "利润",
          key: "profit",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.profit)),
        },
        {
          title: "资金成本",
          key: "agingCost",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.agingCost)),
        },
        {
          title: "成本含资",
          key: "totalCostWithAging",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.totalCostWithAging)),
        },
        {
          title: "资后利润",
          key: "profitAfterAging",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.profitAfterAging)),
        },
        {
          title: "利润率",
          key: "profitRate",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.profitRate, 'percent')),
        },
        {
          title: "资利润率",
          key: "profitRateAfterAging",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.profitRateAfterAging, 'percent')),
        },
        {
          title: "业比利润",
          key: "promoToProfit",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.promoToProfit, 'percent')),
        },
        {
          title: "业比资利",
          key: "promoToProfitAfterAging",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.promoToProfitAfterAging, 'percent')),
        },
        {
          title: "业比销额",
          key: "promoToSalesAmount",
          width: 100,
          align: "right",
          sortable: true,
          render: (h, params) => h("span", this.formatNumber(params.row.promoToSalesAmount, 'percent')),
        },
        {
          title: "-",
          key: "-",
          width: 500,
          render: (h, params) => h("span", '-'),
        },
      ],
    };
  },
  computed: mapState({
    salesOrderProfitList: (state) => state.salesOrder.salesOrderProfitList,
    salesOrderProfitTotalCounts: (state) => state.salesOrder.salesOrderProfitTotalCounts,
  }),
  methods: {
    ...mapActions({
      calcSalesOrderProfit: "salesOrder/calcSalesOrderProfitAction",
      coverSalesOrdersCalc: "salesOrder/coverSalesOrdersCalcAction",
      getSalesOrderProfitList: "salesOrder/getSalesOrderProfitListAction",
    }),
    async loadSalesOrderProfit(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        const data = await this.getSalesOrderProfitList(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    async searchCustomer() {},
    async changeDate(e) {
      this.filterQuery.year = e.split("-")[0];
      this.filterQuery.month = e.split("-")[1];
      try {
        await this.getSalesOrderProfitList(this.filterQuery);
      } catch (error) {
        
      }
    },
    async calcSalesOrderProfitMethed() {
      const date = dayjs(this.yearMonth).format('YYYY-M').split('-')
      const year = date[0]
      const month = date[1]
      try {
        await this.calcSalesOrderProfit({year, month})
      } catch (error) {
        
      }
    },
    async coverSalesOrdersCalcMethed() {
      try {
        await this.coverSalesOrdersCalc()
      } catch (error) {
        
      }
    },
    formatNumber(v, type) {
      if (typeof v === 'number') {
        if (type === 'percent') {
          return (v * 100).toFixed(1) + '%'
        }
        return v.toLocaleString(undefined, {
          minimumFractionDigits: this.numberDigit,
          maximumFractionDigits: this.numberDigit,
        });
      } else {
        return '-'
      }
    },
    handleSummary ({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
          const key = column.key;
          if (index === 0) {
              sums[key] = {
                  key,
                  value: '合计'
              };
              return;
          }
          if (index === 1) {
              sums[key] = {
                  key,
                  value: ''
              };
              return;
          };
          if (key === 'profitRate') {
            const ratio = sums['profit'].v / sums['salesAmountFinal'].v;
              sums[key] = {
                  key,
                  value: (ratio * 100).toFixed(1) + '%'
              };
              return;
          }

          if (key === 'profitRateAfterAging') {
            const ratio = sums['profitAfterAging'].v / sums['salesAmountFinal'].v;
              sums[key] = {
                  key,
                  value: (ratio * 100).toFixed(1) + '%'
              };
              return;
          }

          if (key === 'promoToProfit') {
            const ratio = sums['promoFee'].v / sums['profit'].v;
              sums[key] = {
                  key,
                  value: (ratio * 100).toFixed(1) + '%'
              };
              return;
          }

          if (key === 'promoToProfitAfterAging') {
            const ratio = sums['promoFee'].v / sums['profitAfterAging'].v;
              sums[key] = {
                  key,
                  value: (ratio * 100).toFixed(1) + '%'
              };
              return;
          }

          if (key === 'promoToSalesAmount') {
            const ratio = sums['promoFee'].v / sums['salesAmountFinal'].v;
              sums[key] = {
                  key,
                  value: (ratio * 100).toFixed(1) + '%'
              };
              return;
          }

          const values = data.map(item => Number(item[key]));
          if (!values.every(value => isNaN(value))) {
              const v = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              sums[key] = {
                  key,
                  value: this.formatNumber(v),
                  v
              };
          } else {
              sums[key] = {
                  key,
                  value: '-'
              };
          }
      });

      return sums;
  }
  },
  created() {
    this.curYear = dayjs().format('YYYY')
    this.yearMonth = dayjs().format("YYYY-M");
    this.filterQuery.year = dayjs().year();
    this.filterQuery.month = dayjs().month() + 1;
    this.loadSalesOrderProfit();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>